import { FlagSolid, Flag } from '@assets/svgs';
import { IconButton } from '@components/iconButton/IconButton';
import { useUpdateQuote } from '@services/quotes/useUpdateQuote';

export type ImportantFlagColumnProps = {
  quoteId: string;
  isImportant: boolean;
};

export const ImportantFlagColumn = ({ quoteId, isImportant }: ImportantFlagColumnProps) => {
  const { updateQuote } = useUpdateQuote();

  const handleOnClick = () => {
    const newValue = !isImportant;

    updateQuote({ quoteId: quoteId, uwFlaggedAsImportant: newValue });
  };

  return (
    <IconButton
      variant='circular'
      onClick={handleOnClick}
      sx={{
        color: 'secondary.main',
        width: '28px',
        height: '28px',
        padding: 0,
      }}
    >
      {isImportant ? <FlagSolid width='16px' height='17px' /> : <Flag width='16px' height='17px' />}
    </IconButton>
  );
};
